import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoreHoriz = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.20451 12.7955C4.76516 12.3562 4.76516 11.6438 5.20451 11.2045C5.64385 10.7652 6.35616 10.7652 6.7955 11.2045C7.23484 11.6438 7.23484 12.3562 6.7955 12.7955C6.35616 13.2348 5.64385 13.2348 5.20451 12.7955ZM11.2045 12.7955C10.7652 12.3562 10.7652 11.6438 11.2045 11.2045C11.6438 10.7652 12.3562 10.7652 12.7955 11.2045C13.2348 11.6438 13.2348 12.3562 12.7955 12.7955C12.3562 13.2348 11.6438 13.2348 11.2045 12.7955ZM17.2045 12.7955C16.7652 12.3562 16.7652 11.6438 17.2045 11.2045C17.6438 10.7652 18.3562 10.7652 18.7955 11.2045C19.2348 11.6438 19.2348 12.3562 18.7955 12.7955C18.3562 13.2348 17.6438 13.2348 17.2045 12.7955Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgMoreHoriz);
export default ForwardRef;
